module.exports = __webpack_public_path__ + "static/media/l_skinCare.7a703c9b.png";